var _defs, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTermsBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 255,
    viewBox: "0 0 1920 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.062,
    y1: 0.178,
    x2: 1.069,
    y2: 0.66,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0f73fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2abbfd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13627",
    "data-name": "Rectangle 13627",
    width: 1920,
    height: 255,
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13624",
    "data-name": "Rectangle 13624",
    width: 2090.464,
    height: 191.546,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.369,
    y1: 0.621,
    x2: -1.221,
    y2: -0.29,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00a0ff",
    stopOpacity: 0.529
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4ddff",
    stopOpacity: 0.322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.631,
    y1: 0.621,
    x2: 2.221,
    y2: -0.29,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#61c4ff",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c4ddff",
    stopOpacity: 0.322
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.631,
    y1: 0.621,
    x2: 2.221,
    y2: -0.29,
    xlinkHref: "#linear-gradient-3"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_35722",
    "data-name": "Group 35722",
    transform: "translate(0 -80)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13619",
    "data-name": "Rectangle 13619",
    width: 1920,
    height: 255,
    transform: "translate(0 80)",
    fill: "url(#linear-gradient)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_85",
    "data-name": "Mask Group 85",
    transform: "translate(0 80)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27524",
    "data-name": "Group 27524",
    transform: "translate(-588.962 69.017)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27523",
    "data-name": "Group 27523",
    transform: "translate(0 5.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_82",
    "data-name": "Mask Group 82",
    transform: "translate(866.962 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27520",
    "data-name": "Group 27520",
    transform: "translate(119.289 26.277)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31930",
    "data-name": "Path 31930",
    d: "M-13170.283-10166.842l32.553,24.02h655.594l673.023,34.709,271.7,62.3v-49.306l-854.262-224.7-566.168,158.547-212.439-55.129v49.564Z",
    transform: "translate(13443.983 10319.824)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31929",
    "data-name": "Path 31929",
    d: "M-11873.2-10146.628h-472.135l-552.1,3.352h-267l820.469-169.626,455.156,122.514v47.112Z",
    transform: "translate(13844.172 10314.191)",
    fill: "url(#linear-gradient-4)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31931",
    "data-name": "Path 31931",
    d: "M-11678.12-10178.285l-521.08-2.243-196.152-1.365-627.781,1.365v-1.365l-15.895-2.7,558.986-150.55,591.471,162.217,210.451-53.1v47.742Z",
    transform: "translate(13039.028 10344.367)",
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_31928",
    "data-name": "Path 31928",
    d: "M-11678.12-10178.986l-521.08-2.244-196.152-1.364h-627.781l-15.895-2.7,462.027-151.556,688.43,163.224,210.451-53.1v47.742Z",
    transform: "translate(13039.028 10366.353)",
    fill: "url(#linear-gradient-5)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_31926",
    "data-name": "Path 31926",
    d: "M-13170.283-10160.816l32.553,25.667h655.594l673.023,37.091,271.7,66.572v-52.69l-845.895-247.73-574.535,177.037-212.439-58.911v52.965Z",
    transform: "translate(13443.983 10331.907)",
    fill: "url(#linear-gradient-3)",
    style: {
      mixBlendMode: "luminosity",
      isolation: "isolate"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsBg);
export default __webpack_public_path__ + "static/media/terms_bg.5e5badd8a2c50d388600f65ce4c7d65c.svg";
export { ForwardRef as ReactComponent };